import { GlobalRoutes } from "../../react-router/routes"
import * as UI from "@iyk/ui"
import { Link } from "../../ui/link"

export const FanClipsUploadCard = ({
  title,
  description,
  canUpload
}: {
  title: string
  description: string
  canUpload: boolean
}) => {
  if (!canUpload) {
    return null
  }

  return (
    <section className="flex flex-col gap-4 p-4 bshadow bshadow-gray-5">
      <div className="grid gap-1">
        <h3 className="text-sm text-gray-12">{title}</h3>
        <p className="text-sm text-gray-11">{description}</p>
      </div>
      <Link
        to={GlobalRoutes.fanClips.upload}
        className={UI.classForButton({ size: "sm", kind: "solid", className: "w-max" })}
      >
        Upload
      </Link>
    </section>
  )
}
